<template>
  <el-dialog
    title="报事报修详情页"
    :visible.sync="dialogVisible"
    width="1000px">
      <el-descriptions class="margin-top" :column="2"
                       border
                       contentStyle="max-width: 200px; word-break: break-all"
                       label-style="word-break:keep-all">
        <el-descriptions-item>
          <template slot="label">
            下单人
          </template>
          {{ info['name'] }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            手机号
          </template>
          {{ info['tel'] }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            区域
          </template>
          {{ info['region_name'] }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            项目
          </template>
          {{ info['house_name'] }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            地址
          </template>
          {{ info['address'] }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            类型
          </template>
          {{ info['site_text'] }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            编号
          </template>
          {{ info['services_id'] }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            提交日期
          </template>
          {{ info['created_at'] }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            描述
          </template>
          {{ info['content'] }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            状态
          </template>
          {{ info['stauts_text'] }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            预警
          </template>
          {{ info['is_timeout_text'] }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            评价
          </template>
          {{ info['evaluate'] }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            处理前
          </template>
          <el-carousel height="500px">
            <el-carousel-item v-for="item in info['pics']" :key="item">
              <el-image :src="item" :preview-src-list="info['pics']"></el-image>
            </el-carousel-item>
          </el-carousel>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            处理后
          </template>
          <el-carousel height="500px">
            <el-carousel-item v-for="item in info['after_pics']" :key="item">
              <el-image :src="item" :preview-src-list="info['after_pics']"></el-image>
            </el-carousel-item>
          </el-carousel>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            处理详情
          </template>

          <el-timeline>
            <template v-for="item in repairWorkList">
              <el-timeline-item :timestamp="item.created_at" placement="top" type="primary">
                <el-card>
                  <h4>{{ item.position }}&nbsp;&nbsp;{{ item.nickname }}&nbsp;&nbsp;{{ item.account }}</h4>
                  <p>备注：{{ item.remark }}</p>
                  <p>留言：{{ item.message }}</p>
                </el-card>
              </el-timeline-item>
            </template>
          </el-timeline>

        </el-descriptions-item>
      </el-descriptions>
  </el-dialog>
</template>

<script>

export default {
  name: 'RepairsDetail',
  data() {
    return {
      dialogVisible: false,
      info: [],
      repairWorkList:[]
    }
  },
  mounted() {

  },
  computed: {},
  //事件
  methods: {
    show(repair_id) {
      this.$myhttp.get('admin/getReportForRepairDetail?repair_id=' + repair_id,{
        'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        this.info = backdata.data.info;
        this.repairWorkList = backdata.data.repairWorkList;
      });
      this.dialogVisible=true;
    },

  },

}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Repair/RepairsDetail.vue